/* eslint-disable no-useless-escape */
function getCookie (key) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' +
            encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'
        ),
        '$1'
      )
    ) || null
  )
}
function uploadToExtranet (file) {
  if (!file) return
  let fd = new FormData()
  fd.append('file_up', file)
  fd.append('category', 'daily')
  fd.append('csrf_token', getCookie('bili_jct'))
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', '//api.vc.bilibili.com/api/v1/drawImage/upload', true)
    xhr.withCredentials = true
    xhr.onreadystatechange = () => {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          const { data, code } = JSON.parse(xhr.response)
          if (code === 0) {
            resolve({ url: data.image_url, name: file.name })
          } else if (code === -4) {
            reject(new Error('未登陆'))
          } else {
            reject(new Error('上传失败'))
          }
        }
      }
    }
    xhr.ontimeout = () => {
      reject(new Error('超时请重试'))
    }
    xhr.send(fd)
  })
}

export { uploadToExtranet }
